import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';
import { DEFAULT_ID } from '../../utils/Constants';

const GetContactRelationshipTypesData = (state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      arrayData: [],
      dataAsOptionsWithNames: [],
      ntDataAsOptionsWithNames: [],
      message: 'Loading...'
    };
    setState(newState);

    const url = `/ContactRelationshipType`;
    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const blankContactRelationshipType = { contactRelationshipTypeId: DEFAULT_ID, typeName: '--', isNationalTeamType: true, isNationalTeamTypeOnly: false };
          arrayData.unshift(blankContactRelationshipType);
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            dataAsOptionsWithNames: arrayData.filter((x) => x.isNationalTeamTypeOnly !== true).map((relationshipType) => { return { id: relationshipType.contactRelationshipTypeId, name: relationshipType.typeName } }),
            ntDataAsOptionsWithNames: arrayData.filter((x) => x.isNationalTeamTypeOnly === true || x.isNationalTeamType === true).map((relationshipType) => { return { id: relationshipType.contactRelationshipTypeId, name: relationshipType.typeName } }),
            message: '',
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetContactRelationshipTypesData;